export const MIN_TLS_VERSIONS = [
  {
    key: '1.0',
    label: 'TLS 1.0',
  },
  {
    key: '1.1',
    label: 'TLS 1.1',
  },
  {
    key: '1.2',
    label: 'TLS 1.2',
  },
  {
    key: '1.3',
    label: 'TLS 1.3',
  },
]
